import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {ESettingsFrontType} from '@/config/enums';

export const commonPageRoutes: Array<RouteRecordRaw> = [
  {
    path: '/not_found',
    name: 'NotFoundPage',
    meta: {
      access_mode: [ESettingsFrontType.ADMIN, ESettingsFrontType.CLIENT],
      access_roles: [
        ERoleSystem.ADMIN,
        ERoleSystem.ADMIN_VIEW,
        ERoleSystem.USER,
      ],
    },
    component: () => import('@/app/base/pages/NotFoundPage.vue'),
  },
  {
    path: '/forbidden',
    name: 'ForbiddenPage',
    meta: {
      access_mode: [ESettingsFrontType.ADMIN, ESettingsFrontType.CLIENT],
      access_roles: [
        ERoleSystem.ADMIN,
        ERoleSystem.ADMIN_VIEW,
        ERoleSystem.USER,
      ],
    },
    component: () => import('@/app/base/pages/ForbiddenPage.vue'),
  },
];
